import { formatter } from "@/shared/ts/formatter";
import ChartSeries from "./chartSeries";

export default class TooltipFormatter {
  static SERIES_NAMES = {
    TAX: "Expected Tax",
    SHORTFALL: "Expected shortfall",
    WANT_AFTER_TAX: "What you want after tax",
    EXPECT_AFTER_TAX: "What you can expect to get"
  };

  public static createNew(
    x: number,
    allChartSeries: Array<ChartSeries>
  ): string {
    let tooltip = "<b>Retirement Year " + x + "</b><br/>";
    const dataIndex = x - 1;

    const expectedTax = this.getSeriesValue(
      this.SERIES_NAMES.TAX,
      dataIndex,
      allChartSeries
    );

    const whatYouWant = this.getSeriesValue(
      this.SERIES_NAMES.WANT_AFTER_TAX,
      dataIndex,
      allChartSeries
    );
    const whatYouCanExpect = this.getSeriesValue(
      this.SERIES_NAMES.EXPECT_AFTER_TAX,
      dataIndex,
      allChartSeries
    );

    const shortfall = this.getSeriesValue(
      this.SERIES_NAMES.SHORTFALL,
      dataIndex,
      allChartSeries
    );

    tooltip += this.getTooltipRow(
      "Total income needed",
      whatYouWant + expectedTax
    );
    tooltip += this.getTooltipRow("Expected tax", expectedTax);
    tooltip += this.getTooltipRow(
      this.SERIES_NAMES.WANT_AFTER_TAX,
      whatYouWant
    );
    tooltip += this.getTooltipRow(
      this.SERIES_NAMES.EXPECT_AFTER_TAX,
      whatYouCanExpect
    );
    tooltip += this.getTooltipRow(this.SERIES_NAMES.SHORTFALL, shortfall);

    tooltip +=
      "Click any bar to see how the total income is made up in that year.";

    return tooltip;
  }

  private static getTooltipRow(label: string, value: number) {
    const formattedValue = formatter.formatCurrency(value);
    return `${label}: ${formattedValue}<br/>`;
  }

  private static getSeriesValue(
    name: string,
    dataIndex: number,
    allChartSeries: Array<ChartSeries>
  ): number {
    const chartSeries = allChartSeries.filter(cs => cs.name === name)[0];
    if (chartSeries == null || chartSeries == undefined) {
      return 0;
    }
    return chartSeries.data[dataIndex];
  }
}
